import { computed, Ref, ref } from 'vue'

interface BatchBase {
  id: string
  name: string
  type?: string
  processingItemsCount?: number
  processedItemsCount?: number
}

export function useBatchSelection() {
  const batches: Ref<BatchBase[]> = ref([])

  const selectedBatches: Ref<Record<string, BatchBase>> = ref({})

  const selectedBatchIds = computed(() => Object.keys(selectedBatches.value))

  const selectBatch = (batchId: string) => {
    if (!selectedBatches.value[batchId]) {
      const foundBatch = batches.value.find((batch) => batch.id === batchId)
      if (foundBatch) {
        selectedBatches.value[batchId] = { ...foundBatch }
      }
    }
  }

  const deselectBatch = (batchId: string) => {
    delete selectedBatches.value[batchId]
  }

  const updateBatches = (newBatches: BatchBase[]) => {
    batches.value = newBatches
  }

  return {
    batches,
    selectedBatches,
    selectedBatchIds,
    selectBatch,
    deselectBatch,
    updateBatches,
  }
}
